import { GET_PROFILE, GET_UPDATEPROFILE } from "../../resources/actionTypes";


const initialState = {
    userProfile: [],
    loading: false,
    error: null,
  };

  const initialStateUpdate = {
    userUpdateProfile: [],
    loading: false,
    error: null
  }  

export const userProfile = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILE.GET_PROFILE_REQUESTED:
      return {
        ...state,
        loading: true,
        isAuth: false,
      };
    case GET_PROFILE.GET_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuth: true,
        userProfile: action.userProfile,
      };
    case GET_PROFILE.GET_PROFILE_FAILED:
      return {
        ...state,
        loading: false,
        isAuth: false,
        error: action.message,
      };

    case GET_UPDATEPROFILE.GET_UPDATEPROFILE_REQUESTED:
      return {
        ...state,
        loading: true,
        isAuth: false,
      };
    case GET_UPDATEPROFILE.GET_UPDATEPROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuth: true,
        userProfile: action.userProfile,
      };
    case GET_UPDATEPROFILE.GET_UPDATEPROFILE_FAILED:
      return {
        ...state,
        loading: false,
        isAuth: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export function userUpdateProfile(state = initialStateUpdate, action) {
    switch (action.type) {
      case GET_UPDATEPROFILE.GET_UPDATEPROFILE_REQUESTED:
        return {
          ...state,
          loading: true,
        };
      case GET_UPDATEPROFILE.GET_UPDATEPROFILE_SUCCESS:
        return {
          ...state,
          loading: false,
          userUpdateProfile: action.userUpdateProfile,
        };
      case GET_UPDATEPROFILE.GET_UPDATEPROFILE_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
      default:
        return state;
    }
  }
  
